"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_material_ui_carousel_1 = __importDefault(require("react-material-ui-carousel"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const userReportApi_1 = require("../services/userReportApi");
const react_router_dom_1 = require("react-router-dom");
const react_1 = require("react");
const shared_1 = require("../shared");
const ReportCard_1 = __importDefault(require("./ReportCard"));
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Select_1 = __importDefault(require("@mui/material/Select"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const LocalizationProvider_1 = require("@mui/x-date-pickers/LocalizationProvider");
const AdapterDayjs_1 = require("@mui/x-date-pickers/AdapterDayjs");
const DatePicker_1 = require("@mui/x-date-pickers/DatePicker");
const ToggleButtonGroup_1 = __importDefault(require("@mui/material/ToggleButtonGroup"));
const services_1 = require("../services");
const system_1 = require("@mui/system");
const settings = {
    autoPlay: false,
    indicators: true,
    duration: 600,
    navButtonsAlwaysVisible: false,
    cycleNavigation: true,
    swipe: true,
};
const CustomToggleButton = (0, system_1.styled)(ToggleButton_1.default)(({ theme }) => ({
    fontWeight: 600,
    minWidth: '200px',
    maxWidth: '300px',
    textAlign: 'center',
    fontFamily: 'var(--font-poppins)',
    '&.Mui-selected': {
        backgroundColor: '#043897',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#032e73', // Slightly darker shade on hover
        },
    },
}));
const UserReportList = () => {
    const { userId } = (0, react_router_dom_1.useParams)();
    const [user, setUser] = (0, react_1.useState)({});
    const [diagnostics, setDiagnostics] = (0, react_1.useState)([]);
    const { data: userReportList, isLoading, refetch } = (0, userReportApi_1.useUserReportListQuery)(userId, { refetchOnFocus: true });
    const [testType, setTestType] = (0, react_1.useState)([]);
    const [quiz, setQuiz] = (0, react_1.useState)([]);
    const [alignment, setAlignment] = (0, react_1.useState)(0);
    const { data: testTypeData } = (0, services_1.useTestTypeQuery)({});
    const [filterType, setFilterType] = (0, react_1.useState)('last10');
    const [numTests, setNumTests] = (0, react_1.useState)(10);
    const [dateRange, setDateRange] = (0, react_1.useState)({
        fromDate: null,
        toDate: null
    });
    const initData = async () => {
        setUser(await (0, shared_1.getUserById)(userId));
        setQuiz(await (0, shared_1.getStrapiData)(`diagnostics?&populate=*&pagination[pageSize]=100`));
    };
    console.log('diagnostics', diagnostics);
    const handleChange = (event, newAlignment) => {
        setAlignment(newAlignment);
    };
    const refreshDiagnostics = () => {
        refetch();
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (testTypeData) {
            const test = ((_a = testTypeData === null || testTypeData === void 0 ? void 0 : testTypeData.testTypes) === null || _a === void 0 ? void 0 : _a.data) || [];
            setTestType(test);
        }
    }, [testTypeData]);
    const handleFilterChange = () => {
        if (userReportList === null || userReportList === void 0 ? void 0 : userReportList.diagnostic) {
            let filteredData = [...userReportList.diagnostic];
            filteredData.sort((a, b) => new Date(b.completeDate).getTime() - new Date(a.completeDate).getTime());
            if (alignment === 0) {
                filteredData = filteredData.filter((item) => !item.isBlueBookData && item.type === 1);
            }
            else {
                filteredData = filteredData.filter((item) => item.isBlueBookData || item.type !== 1);
            }
            if (filterType === 'last10') {
                filteredData = filteredData.slice(0, numTests);
            }
            else if (filterType === 'dateRange') {
                const currentDate = new Date();
                filteredData = filteredData.filter((item) => {
                    const completeDate = new Date(item.completeDate);
                    // Only fromDate is present
                    if (dateRange.fromDate && !dateRange.toDate) {
                        return completeDate >= dateRange.fromDate && completeDate <= currentDate;
                    }
                    // Only toDate is present
                    if (!dateRange.fromDate && dateRange.toDate) {
                        return completeDate <= dateRange.toDate;
                    }
                    // Both fromDate and toDate are present
                    if (dateRange.fromDate && dateRange.toDate) {
                        return completeDate >= dateRange.fromDate && completeDate <= dateRange.toDate;
                    }
                    return true;
                });
            }
            const diagnosticList = [];
            const chunkSize = 4;
            for (let i = 0; i < filteredData.length; i += chunkSize) {
                diagnosticList.push(filteredData.slice(i, i + chunkSize));
            }
            setDiagnostics(diagnosticList);
        }
    };
    (0, react_1.useEffect)(() => {
        handleFilterChange();
    }, [userReportList, alignment, filterType, dateRange, numTests]);
    (0, react_1.useEffect)(() => {
        initData();
        refetch();
    }, []);
    if (isLoading)
        return (0, jsx_runtime_1.jsx)("div", { children: "Loading..." });
    return ((0, jsx_runtime_1.jsx)(LocalizationProvider_1.LocalizationProvider, Object.assign({ dateAdapter: AdapterDayjs_1.AdapterDayjs }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { width: '100%', padding: '20px 30px' } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'user-report-list' }, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, mt: 1, width: '100%' } }, { children: [(0, jsx_runtime_1.jsxs)(ToggleButtonGroup_1.default, Object.assign({ color: "primary", value: alignment, sx: { borderRadius: '50px', overflow: 'hidden', border: `1px solid` }, exclusive: true, onChange: handleChange, "aria-label": "Platform" }, { children: [(0, jsx_runtime_1.jsx)(CustomToggleButton, Object.assign({ value: 0 }, { children: "AlphaPrep Full-Length Test Results" })), (0, jsx_runtime_1.jsx)(CustomToggleButton, Object.assign({ value: 1 }, { children: "Uploaded Bluebook Test Results and Skill Building Results" }))] })), (0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ sx: { display: 'flex', alignItems: 'center', gap: 2 } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, { children: "Filter by" }), (0, jsx_runtime_1.jsxs)(Select_1.default, Object.assign({ value: filterType, onChange: (e) => setFilterType(e.target.value), size: "small" }, { children: [(0, jsx_runtime_1.jsx)(MenuItem_1.default, Object.assign({ value: "last10" }, { children: "Recent tests" })), (0, jsx_runtime_1.jsx)(MenuItem_1.default, Object.assign({ value: "dateRange" }, { children: "Date range" }))] })), filterType === 'dateRange' && ((0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ sx: { display: 'flex', gap: 2 } }, { children: [(0, jsx_runtime_1.jsx)(DatePicker_1.DatePicker, { label: "From Date", value: dateRange.fromDate, onChange: (newValue) => setDateRange(prev => (Object.assign(Object.assign({}, prev), { fromDate: newValue }))) }), (0, jsx_runtime_1.jsx)(DatePicker_1.DatePicker, { label: "To Date", value: dateRange.toDate, onChange: (newValue) => setDateRange(prev => (Object.assign(Object.assign({}, prev), { toDate: newValue }))) })] }))), filterType === 'last10' && ((0, jsx_runtime_1.jsx)(TextField_1.default, { label: "Number of Tests", type: "number", size: "small", value: numTests, inputProps: { min: 1 }, onChange: (e) => setNumTests(parseInt(e.target.value, 10)) }))] }))] })), diagnostics.length > 0 ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: { width: '100%', gap: '1vmax' } }, { children: (0, jsx_runtime_1.jsx)(react_material_ui_carousel_1.default, Object.assign({ animation: 'slide', duration: settings.duration, cycleNavigation: settings.cycleNavigation, autoPlay: settings.autoPlay, navButtonsAlwaysVisible: settings.navButtonsAlwaysVisible, indicators: settings.indicators, swipe: settings.swipe }, { children: (diagnostics || []).map((item, i) => ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ container: true, spacing: 2, sx: { p: 1 } }, { children: (item || []).map((data, j) => ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 3 }, { children: (0, jsx_runtime_1.jsx)(ReportCard_1.default, { user: user, testType: testType, quiz: quiz, data: data, refreshDiagnostics: refreshDiagnostics }) }), j))) }), i))) })) }))) : ((0, jsx_runtime_1.jsx)("div", { children: "No data to show" }))] })) })) })));
};
exports.default = UserReportList;
